import { createSlice } from "@reduxjs/toolkit";

// Cross-component "AI is busy" flag — ChatboxNavbar.jsx's "Assign to AI"
// button and TextBox.jsx's composer are siblings (see composerActionsSlice.js
// for the same pattern), but the composer's "Pondering..." loading indicator
// used to be driven by a single local aiAssistLoading state that covered
// every AI action, back when Assign to AI itself lived in the composer.
// Now that the button moved to ChatboxNavbar.jsx (Rahim, 2026-08-29), that
// component needs a way to still light up the composer's loader while its
// own request is in flight — this slice is that bridge.
const aiAssistStatusSlice = createSlice({
  name: "aiAssistStatus",
  initialState: {
    assignToAiLoading: false,
  },
  reducers: {
    setAssignToAiLoading: (state, action) => {
      state.assignToAiLoading = action.payload;
    },
  },
});

export const { setAssignToAiLoading } = aiAssistStatusSlice.actions;
export default aiAssistStatusSlice.reducer;
